import { HOTEL_TYPE_CHANGE } from '../../constants'

const hotelTypeChange = (hotelType, dispatch) => {
  dispatch({ type: HOTEL_TYPE_CHANGE, hotelType })
}

export default type => dispatch => hotelTypeChange(type, dispatch)
